<template>
  <div class="banner-card">
    <a :href="data.link" target="_blank" class="banner-link" @click="trackeoGtm">
      <ImageItem :source="data.image ? data.image : ''"></ImageItem>
    </a>
  </div>
</template>
<script>
/* eslint-disable */
import ImageItem from './ImageItem'
export default {
  name: 'Banner',
  props: {
    data: Object,
    category: String,
    image: String,
    indice: Number
  },
  data () {
    return {
      test: 'Test'
    }
  },
  components: {
    ImageItem
  },
  methods:{
    trackeoGtm(){
        dataLayer.push({
            'event': 'promotionClick',
            'ecommerce': {
              'promoClick': {
                'promotions': [
                {
                  'id': 'banner-card',                         // Nomenclatura del espacio de la imagen
                  'name': this.data.image,                     // Nombre de la imagen
                  'creative': this.data.image,             // URL de la imagen
                  'position': `${this.category}/modulo ${this.indice}`
                }]
              }
            }
        });
    }
  }
}
</script>
<style>
  .banner-card { width:100%;height:385px;}
  .banner-link { display:block; width:100% }
  .banner-link img { width: auto;height: 315px; }
  @media only screen and (min-width: 1000px) {
    .banner-card { width:220px;height:45vh;}
    .banner-link { display:block; width:220px;text-align:center;margin:auto; }
    .banner-link img { width:auto;height:45vh; }
  }
</style>



// WEBPACK FOOTER //
// src/components/BannerComponent.vue